import { render, staticRenderFns } from "./authErrorPage.vue?vue&type=template&id=870e521a&scoped=true&"
var script = {}
import style0 from "./authErrorPage.vue?vue&type=style&index=0&id=870e521a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870e521a",
  null
  
)

export default component.exports